import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const points = [
  <>63% Better & Improved LinkedIn Profile</>,
  <span>
    73% Higher Salary In Desired Domain
    <img
      alt=""
      width={17}
      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/spike.png?updatedAt=1750494807792"
      className="ml-1 inline-block"
    />
  </span>,
  <>Chances Of Landing 4x More Job Offers</>,
];
const PersonaliseCard = ({handlerPersonalise , handlerCertified}) => {
  const certifiedData = useSelector((store)=> store?.certificateVerification?.certifiedData);
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  return (
    <div
      className="w-full flex flex-col items-center justify-start rounded-[16px] p-4"
      style={{ background: "rgba(66, 133, 244, 0.15)" }}
    >
      <div className=" w-full flex items-center gap-3">
        <img
          src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/freepik__the-style-is-modern-and-it-is-a-detailed-illustrat__73803%201.png?updatedAt=1750488522086"
          alt=""
          className="w-[25%]"
        />
        <div className="flex flex-col justify-center">
          <div className="text-[20px] text-white md:text-[22px] font-semibold">
            With This Path, You Get:
          </div>
          <div className="mt-3 flex flex-col gap-3">
            {points?.map((item, index) => (
              <div className="justiify-start flex items-center gap-[6px] text-[10px] md:text-[14px] font-medium text-white/70">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-[#2BBD13]"
                  size="xl"
                />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      <button className="mt-5 px-3 py-3 w-full cursor-pointer rounded-xl bg-[#7FC241] text-[16px] font-medium md:h-[52px] md:text-[18px]" onClick={(e)=> {
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED, { distinct_id: userDetails?.email });
        if(!certifiedData?.is_paid){
          handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})
          console.log('run')
        }
        else{
          console.log('run1')
        handlerCertified({utm_medium : 'get-certified' , utm_source : 'certificate-verification'})

        }
        }}>
        {certifiedData?.desired_job ? `Get A Personalised Path To Become
A ${certifiedData?.desired_job}` : 'Get A Personalised Path For 3x Growth'}
      </button>
    </div>
  );
};

export default PersonaliseCard;
